import React, { useState } from 'react';
import * as XLSX from 'xlsx';
import html2pdf from 'html2pdf.js';

const ExcelToPdf = () => {
  const [tableData, setTableData] = useState([]);

  const handleExcelUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (evt) => {
      const data = new Uint8Array(evt.target.result);
      const workbook = XLSX.read(data, { type: 'array' });

      // Get first sheet
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];

      const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
      setTableData(jsonData);
    };
    reader.readAsArrayBuffer(file);
  };

  const downloadPDF = () => {
    const element = document.getElementById('excel-table');

    html2pdf()
      .set({ filename: 'excel-converted.pdf' })
      .from(element)
      .save();
  };

  return (
    <div>
    <div>
      <h2>Convert Excel to PDF</h2>
      <input type="file" accept=".xlsx, .xls" onChange={handleExcelUpload} />
      <br /><br />

      {tableData.length > 0 && (
        <>
          <div id="excel-table" style={{ padding: 10, backgroundColor: '#fff' }}>
            <table border="1" cellPadding="5" cellSpacing="0">
              <tbody>
                {tableData.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {row.map((cell, colIndex) => (
                      <td key={colIndex}>{cell}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <br />
          <button onClick={downloadPDF}>Download PDF</button>
        </>
      )}
    </div>
    <div className="content">

  <h2>Excel to PDF: Convert Your Spreadsheets into Shareable PDFs</h2>

  <p>
    Excel spreadsheets are powerful for organizing data, creating reports, 
    and performing calculations, but sharing them as editable files can be risky 
    or inconvenient. The Excel to PDF tool allows you to convert your spreadsheets 
    into professional, non-editable PDF documents that retain formatting, charts, 
    and layouts.
  </p>

  <p>
    This ensures your data is presented clearly, looks consistent across devices, 
    and is ready for printing, emailing, or archiving.
  </p>

  <h3>Why Convert Excel to PDF?</h3>

  <ul>
    <li>Preserve formatting, fonts, and layout</li>
    <li>Share data without allowing edits</li>
    <li>Ensure consistent presentation across devices</li>
    <li>Save spreadsheets as compact, portable files</li>
    <li>Prepare professional reports, invoices, and charts</li>
  </ul>

  <h3>How the Excel to PDF Conversion Works</h3>

  <h4>1. Upload Your Excel File</h4>
  <p>
    Select the Excel file (.xls or .xlsx) you want to convert. The tool reads all 
    worksheets, formatting, and embedded charts.
  </p>

  <h4>2. Choose Conversion Options</h4>
  <p>
    Customize your output PDF with options such as:
  </p>
  <ul>
    <li>Select specific sheets to include</li>
    <li>Set page orientation (Portrait or Landscape)</li>
    <li>Adjust page size (A4, Letter, or Original size)</li>
    <li>Scale to fit content on pages</li>
  </ul>

  <h4>3. Generate PDF</h4>
  <p>
    Click “Convert” to generate your PDF. The system preserves formulas, tables, 
    charts, and styling while creating a secure, high-quality document.
  </p>

  <h3>Your Final PDF</h3>
  <p>
    After conversion, you’ll have a professional, shareable PDF that is ready for 
    printing, emailing, or archiving. Your spreadsheet content looks clean, organized, 
    and visually consistent.
  </p>

</div>

    </div>
  );
};

export default ExcelToPdf;
// src/components/ExcelToPDF.js